import React from 'react';
import { connect } from 'react-redux';
import NewsActivityComplete from '../../../../containers/newsActivity/NewsActivityComplete';

const Steps3 = (props) => {

    const { projectName, projectCreater, modalTitle, platform } = props;


    return (
        <div className="steps3">
            <NewsActivityComplete type="专题项目" majorProjectData={{ medias: platform, title: projectName, manager: projectCreater  }}/>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        modalTitle: state.projectReducer.modalTitle,
        projectName: state.projectReducer.projectName,
        projectCreater: state.projectReducer.projectCreater,
        projectContent: state.projectReducer.projectContent,
        platform: state.projectReducer.platform
    }
}

export default connect(mapStateToProps)(Steps3);